import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "prompts" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_PromptsList = _resolveComponent("PromptsList")
  const _component_AddPrompt = _resolveComponent("AddPrompt")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.keep_open)
      ? (_openBlock(), _createBlock(_component_Icon, {
          key: 0,
          icon: "package-open",
          class: "pointer",
          stroke: "#414651",
          width: "1.6rem",
          height: "1.6rem",
          "stroke-width": "1",
          hover: ""
        }))
      : (_openBlock(), _createBlock(_component_IconAsButton, {
          key: 1,
          teleported: "",
          icon: "package-rounded",
          class: "pointer",
          stroke: "#414651",
          size: "1.6rem",
          "stroke-width": "1",
          tooltip: "Saved prompts",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.onOpen()), ["stop"]))
        })),
    _createVNode(_component_PromptsList, {
      ref: "list",
      "modal-to": $data.tp_target,
      onCloseModal: _cache[1] || (_cache[1] = $event => ($options.onCloseModal())),
      onCreate: $options.createPrompt,
      onSelectPrompt: _cache[2] || (_cache[2] = $event => ($options.selectPrompt($event)))
    }, null, 8 /* PROPS */, ["modal-to", "onCreate"]),
    _createVNode(_component_AddPrompt, {
      ref: "add",
      "modal-to": $data.tp_target,
      onCancel: _cache[3] || (_cache[3] = $event => ($options.onAddCancel()))
    }, null, 8 /* PROPS */, ["modal-to"])
  ]))
}